<template>
    <div id="bene-aud-bt-address-container">
        <f7-list form class="form-group" v-if="showFormSet.kaasiDetails">
            <f7-list-input
                input-id     ="address"
                name         ="address"
                type         ="text"

                :label       ="$t('beneficiary-address')"
                :placeholder ="$t('beneficiary-address')"
                :value       ="street"
                @change      ="setStreet($event.target.value); validateInput($event.target); setInput($event.target);"

                autocomplete ="off"
                maxlength    ="100"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'street',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setStreet',
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>